export enum RouteType {
  CONFIRM = "/auth/confirm",
  LOGIN = "/auth/login",
  REGISTER = "/auth/register",
}
